import React from 'react'
import _cx from 'classnames/bind'
import cls from './index.scss'
const cx = _cx.bind(cls)

const BidAtCountyInterstitial = () => (
  <div className={cx('real-auction')} data-elm-id='bid_at_county_interstitial'>
    You will be taken to the{' '}
    <b>
      <i>county site</i>
    </b>{' '}
    that will manage the foreclosure sale. Once you are on the county site, you
    will need to:
    <ul className={cx('real-auction-list')}>
      <li>
        <b>Register</b> for a new account or <b>Sign in</b>
      </li>
      <li>
        <b>Make a deposit </b> on the property before the foreclosure sale is
        scheduled to begin
      </li>
      <li>
        <b>Place a bid</b> on the property that interests you
      </li>
    </ul>
    The sale process may differ slightly from county to county, so please{' '}
    <b>review the Site Guided Tour or Foreclosure Instructions</b> on the
    homepage as well as the appropriate terms and conditions on each county's
    website before bidding.
  </div>
)

export default BidAtCountyInterstitial
